import { getDraggableMultiValueStyles } from 'client/js/common/components/core/PureQueryBuilder/DraggableCompareBy/styles';
import { selectReportActiveMode } from 'client/js/main/selectors/RoiHub';
import { useSelector } from 'client/js/redux';
import type { IndexedOption, MultiValueProps } from 'client/libraries/branch-neo-next/OrderedSelectDropdown/types';

export const useDraggableMultiValueService = (props: MultiValueProps<IndexedOption>) => {
  const activeMode = useSelector(selectReportActiveMode);
  const disabled = activeMode === 'tree' && props.data.index > 3;
  const css = getDraggableMultiValueStyles(disabled);

  const onMouseDown = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  const innerProps = { ...props.innerProps, onMouseDown };

  return { css, innerProps, disabled };
};
